import { aboutResources } from "../Resources/About";
import { getLang } from "../lib";
import FadeInOnScroll from "./FadeInOnScroll";
import "./Home.css";
import { dropdownIds } from "../Resources/SharedResources";

function About() {
    const lang = getLang();
    document.title = aboutResources[lang].Title;

    const TextSection = ({ title, paragraphs, delay = 0.2 }) => (
        <FadeInOnScroll delay={delay}>
            <section className="txt-holder child-item">
                <h1>{title}</h1>
                {paragraphs.map((text, idx) => (
                    <p key={idx} style={{ marginBottom: "1rem" }} dangerouslySetInnerHTML={{ __html: text }} />
                ))}
            </section>
        </FadeInOnScroll>
    );

    const ImageSection = ({ src, alt, delay = 0.4, reverse = false }) => (
        <div className={`page-item ${reverse ? "reverse" : ""}`}>
            <FadeInOnScroll delay={delay}>
                <div className="img-holder child-item">
                    <img src={src} alt={alt} />
                </div>
            </FadeInOnScroll>
        </div>
    );

    const CardSection = ({ id, title, cards }) => (
        <section id={id} className="value-prop">
            <h2 className="section-title">{title}</h2>
            <div className="why-us-grid">
                {cards.map((card, idx) => (
                    <FadeInOnScroll key={idx} delay={0.2 + idx * 0.1}>
                        <div className="why-card">
                            <div className="icon">{card.icon}</div>
                            <p>{card.title}</p>
                        </div>
                    </FadeInOnScroll>
                ))}
            </div>
        </section>
    );

    return (
        <div id={dropdownIds.about.overview} className="about-us-page">
            {/* Header */}
            <section className="about-us">
                <FadeInOnScroll delay={0.2}>
                    <h1>{aboutResources[lang].Title}</h1>
                    {aboutResources[lang].Description.map((paragraph, idx) => (
                        <p key={idx} style={{ marginBottom: "1rem" }} dangerouslySetInnerHTML={{ __html: paragraph }} />
                    ))}
                </FadeInOnScroll>
            </section>

            {/* Mission */}
            <div id={dropdownIds.about.mission} className="page-item">
                <TextSection
                    title={aboutResources[lang].MissionTitle}
                    paragraphs={[aboutResources[lang].MissionText]}
                    delay={0.3}
                />
                <ImageSection src="/images/mission.jpeg" alt="Our Mission" delay={0.4} />
            </div>

            {/* Vision */}
            <div className="page-item reverse">
                <TextSection
                    title={aboutResources[lang].VisionTitle}
                    paragraphs={[aboutResources[lang].VisionText]}
                    delay={0.3}
                />
                <ImageSection src="/images/vision.jpeg" alt="Our Vision" delay={0.4} />
            </div>

            {/* Who We Are */}
            <CardSection
                id={dropdownIds.about.whoWeAre}
                title={aboutResources[lang].WhoWeAreTitle}
                cards={aboutResources[lang].WhoWeAreCards}
            />

            {/* Our Approach */}
            <CardSection
                id={dropdownIds.about.approach}
                title={aboutResources[lang].ApproachTitle}
                cards={aboutResources[lang].ApproachCards}
            />
        </div>
    );
}

export default About;
